export const DotIcon = () => {
	return (
		<div
			style={{
				paddingLeft: 8,
				paddingRight: 8,
				display: "flex",
				alignItems: "center",
			}}
		>
			<div
				style={{
					width: "4px",
					height: "4px",
					flexGrow: 0,
					backgroundColor: "#367bf5",
					borderRadius: "50%",
				}}
			></div>
		</div>
	);
};
